import {
  setContractQueryAction,
  setMonthQueryAction,
} from '../../redux/actions/Actions';
import {appStore} from '../../redux/createStore';
import {getCountryCode} from '../../utils/util';
import DocTypesForContractFiltering from '../documentDownload/raiseDownloadRequest/DocTypesForContractFiltering.json';
import {months} from '../futurePaymentGraph/graphConfig';
import './contractYearDropdown.css';

import {InputLabel, Option, Select} from '@deere/fuel-react';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

const ContractYearDropdown = (props) => {
  const [contractList, setContractList] = React.useState(null);
  const [yearList, setYearList] = React.useState(null);
  const [selectedContract, setSelectedContract] = React.useState(null);
  const [selectedYear, setSelectedYear] = React.useState(null);
  const [showMonths, setShowMonths] = React.useState(false);
  const [selectedMonth, setSelectedMonth] = React.useState(null);
  const ALLCONTRACT = 'ALL_CONTRACTS';
  const FULLSCHEDULE = 'FULL_SCHEDULE';
  const {t} = useTranslation();

  const getContracts = () => {
    if (props.contracts) {
      let contractList = [];
      if (!props.docType) {
        contractList = props?.contractFilterBy?.length
          ? props.contracts?.reduce((acc, contract) => {
              if (props.contractFilterBy.includes(contract.productLine)) {
                acc.push(contract.contractNumber);
              }
              return acc;
            }, [])
          : props.contracts.map((contract) => {
              return contract.contractNumber;
            });
      } else if (
        props.docType !== 'LIEN_DE_REGISTRATION_LETTERS' &&
        props.docType !== 'FINAEN'
      ) {
        for (const contract of props.contracts) {
          const productLine = contract.productLine;
          if (
            props.country &&
            DocTypesForContractFiltering[props.country][productLine]?.includes(
              props.docType
            )
          ) {
            contractList.push(contract.contractNumber);
          }
        }
      } else if (props.docType === 'FINAEN') {
        for (const contract of props.pastContracts) {
          const productLine = contract.productLine;
          if (
            props.country &&
            DocTypesForContractFiltering[props.country][productLine]?.includes(
              props.docType
            )
          ) {
            contractList.push(contract.contractNumber);
          }
        }
        for (const contract of props.contracts) {
          const productLine = contract.productLine;
          if (
            props.country &&
            DocTypesForContractFiltering[props.country][productLine]?.includes(
              props.docType
            )
          ) {
            contractList.push(contract.contractNumber);
          }
        }
      } else {
        for (const contract of props.pastContracts) {
          const productLine = contract.productLine;
          if (
            props.country &&
            DocTypesForContractFiltering[props.country][productLine]?.includes(
              props.docType
            )
          ) {
            contractList.push(contract.contractNumber);
          }
        }
      }

      setContractList(contractList);
      if (props.queryContract) {
        setSelectedContract(props.queryContract);
        if (props.queryContract === ALLCONTRACT) {
          getAllYears(ALLCONTRACT);
        } else {
          getYears(props.queryContract);
        }
      } else {
        setSelectedContract(contractList[0]);
        props.showYear
          ? getYears(contractList[0])
          : props.onDropdownChange(contractList[0]);
      }
    }
  };

  const dropDownCallback = (
    contract,
    yearList,
    currentMonth,
    selectedYear = null
  ) => {
    let setYear;
    if (selectedYear) {
      setYear = selectedYear;
    } else if (yearList.includes(props.defaultYear)) {
      setYear = props.defaultYear;
    } else {
      setYear = yearList.at(-1);
    }
    setSelectedYear(+setYear);
    props.onDropdownChange(contract, setYear, currentMonth);
  };

  const getYears = (contract) => {
    let yearList = [];
    props.contracts.forEach((data) => {
      if (data.contractNumber === contract) {
        let startYear = new Date(data.startDate).getFullYear();
        let endYear = new Date(data.endDate).getFullYear();
        if (props.scheduleInstallments?.[contract]?.secondaryPeriod) {
          endYear = new Date(
            props.scheduleInstallments[
              contract
            ].secondaryPeriod.lastInstallmentDueDate
          ).getFullYear();
        }
        for (let i = startYear; i <= endYear; i++) yearList.push(i);
      }
    });
    setYearList(yearList);
    dropDownCallback(contract, yearList);
  };

  const getAllYears = (contract) => {
    props.showMonths ? setShowMonths(true) : setShowMonths(false);
    let yearList = [];
    let startYear = 0;
    let endYear = 0;
    props.contracts.forEach((data) => {
      if (props?.scheduleInstallments?.[data.contractNumber]?.secondaryPeriod) {
        data.endDate =
          props.scheduleInstallments[
            data.contractNumber
          ].secondaryPeriod.lastInstallmentDueDate;
      }
      if (
        startYear === 0 ||
        startYear > new Date(data.startDate).getFullYear()
      ) {
        startYear = new Date(data.startDate).getFullYear();
      }
      if (endYear < new Date(data.endDate).getFullYear()) {
        endYear = new Date(data.endDate).getFullYear();
      }
    });
    for (let i = startYear; i <= endYear; i++) yearList.push(i);
    setYearList(yearList);
    let currentMonth;
    let selectedYear;
    if (props.queryMonth) {
      const monthYear = props.queryMonth.split(' ');
      currentMonth = monthYear[0];
      selectedYear = 20 + '' + monthYear[1];
    } else {
      currentMonth = props.defaultMonth
        ? props.defaultMonth
        : months[getCountryCode()][new Date().getMonth()];
    }
    setSelectedMonth(currentMonth);
    dropDownCallback(contract, yearList, currentMonth, selectedYear);
  };

  const onChangeHandler = (field, value) => {
    if (props.queryContract) appStore.dispatch(setContractQueryAction(null));
    if (field === 'contractOption') {
      if (props.queryMonth) appStore.dispatch(setMonthQueryAction(null));
      setSelectedContract(value);
      if (value === ALLCONTRACT) {
        getAllYears(value);
      } else {
        showMonths && setShowMonths(false);
        getYears(value);
      }
    } else if (field === 'monthOption') {
      if (props.queryMonth) appStore.dispatch(setMonthQueryAction(null));
      setSelectedMonth(value);
      props.onDropdownChange(selectedContract, selectedYear, value);
    } else {
      setSelectedYear(value);
      props.onDropdownChange(selectedContract, value, selectedMonth);
    }
  };

  React.useEffect(() => {
    getContracts();
  }, [props.contracts, props.docType, props.contractFilterBy]);

  React.useEffect(() => {
    if (props.assetContractOption)
      onChangeHandler('contractOption', props.assetContractOption);
  }, [props.assetContractOption]);

  return (
    <div
      className={`contractYearDropdownWrapper ${
        showMonths ? 'multiDropdown' : ''
      }`}
    >
      {contractList && (
        <div className="contractDropdownWrapper">
          <InputLabel htmlFor="select-widget" id="select-label">
            {t('CONTRACT_NUMBER')}
          </InputLabel>
          <Select
            id="contractDropdown"
            defaultValue={selectedContract}
            size="small"
            value={selectedContract}
          >
            {contractList.map((contractNo, index) => (
              <Option
                id={'contractOption' + index}
                value={contractNo}
                key={'contractOption' + contractNo}
                onClick={() => onChangeHandler('contractOption', contractNo)}
              >
                {contractNo}
              </Option>
            ))}
            {props.allContracts &&
              props.contractCount > 1 &&
              selectedYear !== FULLSCHEDULE && (
                <Option
                  id={'allContractOption'}
                  value={ALLCONTRACT}
                  key={'allContractOption'}
                  onClick={() => onChangeHandler('contractOption', ALLCONTRACT)}
                >
                  {t(ALLCONTRACT)}
                </Option>
              )}
          </Select>
        </div>
      )}
      {showMonths && (
        <div className="contractDropdownWrapper">
          <InputLabel htmlFor="select-widget" id="select-label">
            {t('MONTH')}
          </InputLabel>
          <Select
            id="monthDropdown"
            defaultValue={selectedMonth}
            size="small"
            value={selectedMonth}
          >
            {months[getCountryCode()].map((monthName, index) => (
              <Option
                id={'monthOption' + index}
                value={monthName}
                key={'monthOption' + monthName}
                onClick={() => onChangeHandler('monthOption', monthName)}
              >
                {monthName}
              </Option>
            ))}
          </Select>
        </div>
      )}
      {props.showYear && (
        <div className="contractDropdownWrapper">
          <InputLabel htmlFor="select-widget" id="select-label">
            {t('YEAR')}
          </InputLabel>
          <Select
            id="yearDropdown"
            placeholder=""
            defaultValue={selectedYear ?? ''}
            size="small"
            value={selectedYear ?? ''}
          >
            {selectedContract !== ALLCONTRACT && (
              <Option
                id={'fullScheduleOption'}
                value={FULLSCHEDULE}
                key={'fullScheduleOption'}
                onClick={() => onChangeHandler('yearOption', FULLSCHEDULE)}
              >
                {t(FULLSCHEDULE)}
              </Option>
            )}
            {yearList?.map((year, index) => (
              <Option
                id={'yearOption'}
                value={year}
                key={'yearOption' + year}
                onClick={() => onChangeHandler('yearOption', year)}
              >
                {year}
              </Option>
            ))}
          </Select>
        </div>
      )}
    </div>
  );
};

ContractYearDropdown.propTypes = {
  docType: PropTypes.string,
  contracts: PropTypes.array,
  country: PropTypes.string,
  pastContracts: PropTypes.array,
};

export const mapStateToProps = (state) => {
  return {
    country: state.appStates.allContracts?.countryCode,
    contracts: state.appStates.contractNumbers?.contracts,
    pastContracts: state.appStates.contractNumbers?.pastContracts,
    contractCount: state.appStates.contractNumbers?.contractCounts,
    queryContract: state.appStates.queryContract,
    queryMonth: state.appStates.queryMonth,
    contractDetails: state.appStates.contractDetails?.accountDetails,
    scheduleInstallments:
      state.appStates.paymentSchedule?.paymentSchedules?.installments,
  };
};
export default connect(mapStateToProps)(ContractYearDropdown);
